import { gql } from '@apollo/client';
import { FileType } from '@/types';

export const PERSONAL_RESULTS = gql`
  query personalResults($personalId: PersonalId!) {
    client {
      id
      employee(personalId: $personalId) {
        id
        personalId
        staffCode
        firstName
        lastName
        joinedAt
        retiredAt
        employmentType
        groups
        position
        regularHealthCheckupResults {
          id
          dateOn
        }
      }
    }
  }
`;

export interface PersonalResultsQueryVariables {
  personalId: string;
}

export interface PersonalResultsQueryResult {
  client: {
    employee: Employee;
  };
}

export const REGULAR_HEALTH_CHECKUP_RESULT = gql`
  query regularHealthCheckupResult($personalId: PersonalId!, $resultId: ID!) {
    client {
      regularHealthCheckupResult(personalId: $personalId, resultId: $resultId) {
        id
        office {
          id
          name
        }
        healthCheckupInstitution {
          id
          name
          location
        }
        dateOn
        orderByDoctor
        report
        specifiedWorkCode
        regularHealthCheckupResultItems {
          id
          itemCode
          checked
          hasFinding
          value
          evaluation
        }
      }
    }
  }
`;

export interface RegularHealthCheckupResultQueryVariables {
  personalId: string;
  resultId: string;
}

export interface RegularHealthCheckupResultQueryResult {
  client: {
    regularHealthCheckupResult: RegularHealthCheckupResult | null;
  };
}

export interface Employee {
  id: string;
  personalId: string;
  staffCode?: string;
  firstName?: string;
  lastName?: string;
  joinedAt?: string;
  retiredAt?: string;
  employmentType?: string;
  groups?: string[];
  position?: string;
  regularHealthCheckupResults: PartialRegularHealthCheckupResult[];
}

export interface PartialRegularHealthCheckupResult {
  id: string;
  dateOn: string;
}

export interface RegularHealthCheckupResult {
  id: string;
  office?: Office;
  healthCheckupInstitution?: HealthCheckupInstitution;
  dateOn: string;
  orderByDoctor: boolean;
  report?: FileType;
  specifiedWorkCode?: string;
  regularHealthCheckupResultItems: RegularHealthCheckupResultItem[];
}

interface Office {
  id: string;
  name: string;
}

interface HealthCheckupInstitution {
  id: string;
  name: string;
  location: string;
}

export interface RegularHealthCheckupResultItem {
  id: string;
  itemCode: string;
  checked: boolean;
  hasFinding: boolean;
  value?: string;
  evaluation?: string;
}
